module.exports = __webpack_public_path__ + "media/colors.34d2d7bf.mp4";